import { Inject, Injectable, ElementRef, PLATFORM_ID } from '@angular/core';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http'; 
import { Observable, throwError } from 'rxjs';
import 'rxjs';
import { DOCUMENT } from '@angular/common';
import { SvcServices } from 'app/services/svc.service';
import {GuidService} from 'app/services/guid.service';
import { BehaviorSubject } from 'rxjs';
import { Router,NavigationEnd,ActivatedRoute  } from '@angular/router'; 


import { isPlatformBrowser } from '@angular/common';
import { resolveLangParams, toggleSiteLocale } from '../utils/lang.util';

@Injectable()
export class LanguageToggleService {
  config: any;
  endpointMap: any;
  channel: any;
  endpoints: Map<string, string>;

  constructor(private _http: HttpClient,
    private _svcService: SvcServices,
    private el: ElementRef,
    private guidService: GuidService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document,
    public _appConfigService: AppConfigService,
    //private _storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: string) {
    var { protocol, hostname, port } = (!isPlatformBrowser(this.platformId)) ? this._appConfigService.getConfig("apiServerUrlPlatformServer") : this.document.location;

    this.setConfig();
    }

    setConfig() {
    this.config = this._appConfigService.getConfig("api");
    // api = this.config;
    this.endpointMap =
      Object
        .keys(this.config?.endpoints)
        .reduce((map, endpoint, i) => {
          map[i] = [endpoint, this.config?.endpoints[endpoint]];
          return map;
        }, []);
    this.channel = this.config?.channel;
    this.endpoints = new Map(this.endpointMap);
  }
    public token: string;
    public bizToken: string;
    businessId: any;
    // public endpoints: Map<string, string> = new Map(this.endpointMap);
    /**
     * The URL for connecting to API endpoints.
     */
    private url: string;
    private langToggleObservable = new BehaviorSubject<any>(null);
    public langToggleResponse = this.langToggleObservable.asObservable();

    public updateLangIdOnLoad(queryParams: any) {
      const { siteLocale, lang } = resolveLangParams(queryParams);
      localStorage.setItem('siteLocal_ID', siteLocale);
      this.document.documentElement.setAttribute('lang', lang);
    }
    
    public getCurrentSiteLocale(){
        return localStorage.getItem('siteLocal_ID') ?? 'en_US';
    }
    public reloadCurrentRoute(){
        let urlTree = this.router.parseUrl(this.router.url);
        urlTree.queryParams['langId'] = this.getCurrentSiteLocale();
        let url = this.router.createUrlTree([window.location.pathname], {queryParams : urlTree.queryParams}).toString();
        setTimeout(()=>{
            window.location.href = url;
        },250);
        //this.router.navigate([this.router.url.split('?')[0]],{queryParams: urlTree.queryParams, replaceUrl: true});
    }
    
    public switchSiteLocale(){
        const currentLocal = localStorage.getItem('siteLocal_ID');
        if(currentLocal){
            localStorage.setItem('siteLocal_ID', toggleSiteLocale(currentLocal));
        }
        this.reloadCurrentRoute();
    }
    public toggleLanguage() {
        const data = {};
        const url = this.endpoints.get('languageToggleURL');

        console.log("this is the URL endpoint for langtoggle:", this.endpoints.get('languageToggleURL'));

        console.log("url from toggleLanguage()", url);

        const currentLocale = localStorage.getItem('siteLocal_ID') ?? 'en_US';
        console.log("currentLocale in toggleLanguage()", currentLocale);
        this.switchSiteLocale();
        // TODO: Update logic for known and unknown users 
        // let headers = new Headers({
        //     'uuid': this.guidService.getGuid(),
        //     'Accept-Language': currentLocale,
        //     'Content-Type': 'application/json',
        //     ...(this._appConfigService.getConfig("api").headers),
        //     ...(this.token ? { Authorization: this.token } : {}),
        //     ...(this.bizToken ? { bizToken: this.bizToken } : {}),
        // });
        // return this._http.post(url,data, { headers: headers }).map((res: Response) => {
        //     this.langToggleObservable.next(res);
        //     return res;
        // }).catchError((error) => this.handleError(error));
    }

    handleError(error: HttpErrorResponse) {
        return throwError(error.statusText)
    }
}
